app.controller('LoginCtrl',
    ['$scope', '$rootScope', '$http', '$window', '$q',
    function ($scope, $rootScope, $http, $window, $q) {
    $scope.user = {
        Email: '',
        Password: '',
    };
    
    $scope.brokername = '';

        // toggle password plaintext
    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

    var allPromise = $q.all([
        $http({
            method: 'GET',
            url: 'service/client.svc/SignOut',
        }).then(function (data) {
        }, function (error) { }),

        $http({
            method: 'GET',
            url: 'service/client.svc/GetPED',
            cache:false,
        }).then(function (data) {

            if (data.data.d != null) {
                $scope.broker = data.data.d;
                $scope.brokername = $scope.broker.BROKERName;
                if ($scope.brokername == 'PT IDXSTI Sekuritas')
                    $scope.brokername = 'PT IDXSTI Sekuritas';
            }
        }, function (error) { }),
    ]);

    $scope.working = false;
    $scope.loadMessage = 'Loading...';

    $scope.after_login = {};

    $scope.trim = function(){
        $scope.user.Email=$scope.user.Email?$scope.user.Email.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.user.Email;
        $scope.user.Password=$scope.user.Password?$scope.user.Password.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.user.Password;
    }

    $scope.submit = function () {
        //$rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
        $scope.trim();
        var password = btoa($scope.user.Password);
        $scope.working = true;
        $http({
            method: 'POST',
            url: 'service/client.svc/LoginUser',
            data: {
                UserLogin: {
                    Email: $scope.user.Email,
                    Password: $scope.user.Password,
                }
            },
        }).then(function (data) {
            

            $scope.working = false;
            $scope.result = data.data.d;

            console.log('STAGE ', $scope.result);
            var SWALtranslate = $scope.SWALtranslate($scope.result.message);

            if ($scope.result.message == "notactivated") {

                $rootScope.AlertShowFooter('warning', SWALtranslate.title, SWALtranslate.message,
                    `<small><a id="resendOTP" >` + SWALtranslate.footer + `</a></small>`, 0);

                $("#resendOTP").on("click", function () {

                    var urlsvc = 'service/client.svc/resendOTP?emailto=' + $scope.user.Email; // 1
                    var preconfirmtranslate = "resendactivationlink"; // 2 
                    var postData = {}; // 3
                    var method = "GET"; // 4
                    $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                        if (issuccess) // 6 
                            $window.location.href = "#/login";
                    });
                });
                return
            }

            if ($scope.result.result) {
                
                if ($scope.result.IsFinished == 1 || $scope.result.IsRevised == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                }
                else
                {
                        console.log('STAGE NEW',$scope.result.Stage);

                        if ($scope.result.Stage || $scope.result.Stage == 0) {
                            if ($scope.result.Stage == 0 && $scope.broker.OAO) {
                                console.log('STAGE 1');
                                $window.location.href = "#/cif/start";
                                $window.location.reload();
                            }
                            if ($scope.result.Stage == 1) {
                                $window.location.href = "#/cif/data-pribadi";
                                $window.location.reload();
                            }
                            if ($scope.result.Stage == 2) {
                                $window.location.href = "#/cif/data-pekerjaan";
                                $window.location.reload();
                            }
                            if ($scope.result.Stage == 3) {
                                $window.location.href = "#/cif/data-pendukung";
                                $window.location.reload();
                            }
                            if ($scope.result.Stage == 4) {
                                if ($scope.result.IsFinished == 1) {
                                    $window.location.href = "#/dashboard";
                                    $window.location.reload();
                                } else {
                                    $window.location.href = "#/cif/data-pernyataan";
                                }

                                if ($scope.result.IsRevised == 1) {
                                    $window.location.href = "#/dashboard";
                                    $window.location.reload();
                                }
                            }
                        }
                }

               
            }
            else {
                $rootScope.GlobalAlert('warning', SWALtranslate.title, SWALtranslate.message, 0);
            }
        },
        function (error) {
            console.log('fail login');
        });
    };



    allPromise.then(function () {

    });

    // toggle password plaintext
    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

}]);
